import { HiMenuAlt2 } from 'react-icons/hi';
import { useTheme } from 'styled-components';

import { useSidebar } from '../SidebarContext';
import * as s from './styles';

const MobileToggleBtnTSX = () => {
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const theme = useTheme();

  return (
    <s.MobileBarContainer
      isSidebarOpen={isSidebarOpen}
      onClick={(e) => {
        e.stopPropagation();
        toggleSidebar();
      }}
      aria-label="Abrir menu"
    >
      <HiMenuAlt2 color={theme.colors.onPrimary} />
    </s.MobileBarContainer>
  );
};

export default MobileToggleBtnTSX;
